import { Header } from "components";

import { ContentLayoutProps } from "./ContentLayout.types";

const ContentLayout = ({
  children,
  title,
  counter,
  action = null
}: ContentLayoutProps) => {
  return (
    <>
      <Header title={title} action={action} counter={counter} />
      {children}
    </>
  );
};

export default ContentLayout;
